var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c("div", { staticClass: "statistics-card" }, [
        _c("div", { staticClass: "stat-item stat-item-primary" }, [
          _c("span", { staticClass: "stat-value" }, [
            _vm._v(_vm._s(_vm.statistics.continuousBondCount))
          ]),
          _c("span", { staticClass: "stat-label" }, [_vm._v("有效年度Bond")])
        ]),
        _c("div", { staticClass: "stat-item stat-item-warning" }, [
          _c("span", { staticClass: "stat-value" }, [
            _vm._v(_vm._s(_vm.statistics.expiringBondCount))
          ]),
          _c("span", { staticClass: "stat-label" }, [_vm._v("30天内到期Bond")])
        ]),
        _c("div", { staticClass: "stat-item stat-item-danger" }, [
          _c("span", { staticClass: "stat-value" }, [
            _vm._v(_vm._s(_vm.statistics.expiredBondCount))
          ]),
          _c("span", { staticClass: "stat-label" }, [_vm._v("已过期Bond")])
        ]),
        _c("div", { staticClass: "stat-item stat-item-info" }, [
          _c("span", { staticClass: "stat-value" }, [
            _vm._v(_vm._s(_vm.statistics.stbBondCount))
          ]),
          _c("span", { staticClass: "stat-label" }, [_vm._v("STB单次Bond")])
        ])
      ]),
      _c(
        "div",
        { staticClass: "search-form" },
        [
          _c(
            "el-form",
            {
              staticClass: "search-form-inline",
              attrs: { inline: true, model: _vm.searchForm }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "进口商名称" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入进口商名称", clearable: "" },
                    model: {
                      value: _vm.searchForm.importerName,
                      callback: function($$v) {
                        _vm.$set(_vm.searchForm, "importerName", $$v)
                      },
                      expression: "searchForm.importerName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Importer No" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入Importer No", clearable: "" },
                    model: {
                      value: _vm.searchForm.importerNo,
                      callback: function($$v) {
                        _vm.$set(_vm.searchForm, "importerNo", $$v)
                      },
                      expression: "searchForm.importerNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Bond编号" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入Bond编号", clearable: "" },
                    model: {
                      value: _vm.searchForm.bondNo,
                      callback: function($$v) {
                        _vm.$set(_vm.searchForm, "bondNo", $$v)
                      },
                      expression: "searchForm.bondNo"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Bond类型" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.searchForm.bondType,
                        callback: function($$v) {
                          _vm.$set(_vm.searchForm, "bondType", $$v)
                        },
                        expression: "searchForm.bondType"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "年度Continuous Bond", value: "1" }
                      }),
                      _c("el-option", {
                        attrs: { label: "单次STB Bond", value: "2" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择",
                        clearable: "",
                        multiple: "",
                        "collapse-tags": ""
                      },
                      model: {
                        value: _vm.searchForm.status,
                        callback: function($$v) {
                          _vm.$set(_vm.searchForm, "status", $$v)
                        },
                        expression: "searchForm.status"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "未生效", value: "1" }
                      }),
                      _c("el-option", { attrs: { label: "生效", value: "2" } }),
                      _c("el-option", {
                        attrs: { label: "到期预警", value: "3" }
                      }),
                      _c("el-option", {
                        attrs: { label: "已过期", value: "4" }
                      }),
                      _c("el-option", { attrs: { label: "作废", value: "5" } })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "海关核验" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择",
                        clearable: "",
                        multiple: "",
                        "collapse-tags": ""
                      },
                      model: {
                        value: _vm.searchForm.customsVerify,
                        callback: function($$v) {
                          _vm.$set(_vm.searchForm, "customsVerify", $$v)
                        },
                        expression: "searchForm.customsVerify"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "未核验", value: "1" }
                      }),
                      _c("el-option", {
                        attrs: { label: "已核验有效", value: "2" }
                      }),
                      _c("el-option", {
                        attrs: { label: "编号无效", value: "3" }
                      }),
                      _c("el-option", { attrs: { label: "过期", value: "4" } }),
                      _c("el-option", {
                        attrs: { label: "额度不足", value: "5" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSearch }
                    },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { on: { click: _vm.handleReset } }, [
                    _vm._v("重置")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "toolbar" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", icon: "el-icon-plus" },
              on: { click: _vm.handleAdd }
            },
            [_vm._v("新增Bond")]
          ),
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-view" },
              on: { click: _vm.handleBatchVerify }
            },
            [_vm._v("批量海关核验")]
          ),
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-delete" },
              on: { click: _vm.handleBatchInvalid }
            },
            [_vm._v("批量作废")]
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticClass: "bond-management-hover",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            "row-key": "uuid",
            "row-style": _vm.tableRowStyle
          },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: { type: "selection", width: "55", "reserve-selection": true }
          }),
          _c("el-table-column", {
            attrs: { prop: "importerName", label: "进口商名称" }
          }),
          _c("el-table-column", {
            attrs: { prop: "importerNo", label: "Importer No" }
          }),
          _c("el-table-column", {
            attrs: { prop: "bondNo", label: "Bond编号" }
          }),
          _c("el-table-column", {
            attrs: { prop: "bondTypeName", label: "Bond类型" }
          }),
          _c("el-table-column", {
            attrs: { prop: "guarantor", label: "担保公司/人" }
          }),
          _c("el-table-column", {
            attrs: { prop: "bondAmount", label: "Bond金额(USD)" }
          }),
          _c("el-table-column", {
            attrs: { prop: "effectiveExpiryDate", label: "生效/到期" }
          }),
          _c("el-table-column", {
            attrs: { prop: "statusName", label: "状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.statusName
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getStatusTagType(scope.row.status),
                              size: "small"
                            }
                          },
                          [_vm._v(_vm._s(scope.row.statusName))]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "customsVerifyName", label: "海关核验" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.customsVerifyName
                      ? _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getCustomsVerifyTagType(
                                scope.row.customsVerify
                              ),
                              size: "small"
                            }
                          },
                          [_vm._v(_vm._s(scope.row.customsVerifyName))]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "operation-buttons" },
                      [
                        scope.row.status !== "5"
                          ? _c(
                              "el-button",
                              {
                                attrs: { size: "mini" },
                                on: {
                                  click: function($event) {
                                    return _vm.handleEdit(scope.row)
                                  }
                                }
                              },
                              [_vm._v("编辑")]
                            )
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini" },
                            on: {
                              click: function($event) {
                                return _vm.handleLog(scope.row)
                              }
                            }
                          },
                          [_vm._v("Bond日志")]
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.pagination.pageNum,
          "page-sizes": [10, 20, 50, 100],
          "page-size": _vm.pagination.pageSize,
          total: _vm.pagination.total,
          layout: "total, sizes, prev, pager, next, jumper"
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange
        }
      }),
      _c("bond-form", {
        ref: "bondForm",
        on: { "save-success": _vm.handleSaveSuccess }
      }),
      _c("customs-verify-modal", {
        ref: "customsVerifyModal",
        on: { "verify-success": _vm.handleVerifySuccess }
      }),
      _c("bond-log-modal", { ref: "bondLogModal" }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "确认作废",
            visible: _vm.invalidDialogVisible,
            width: "400px"
          },
          on: {
            "update:visible": function($event) {
              _vm.invalidDialogVisible = $event
            }
          }
        },
        [
          _c("p", [
            _vm._v(
              "确认作废 " +
                _vm._s(_vm.selectedData.length) +
                " 条Bond？此操作不可恢复"
            )
          ]),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.invalidDialogVisible = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmInvalid }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }